// extracted by mini-css-extract-plugin
export default {"btn":"lpButton_btn__2UfJI"};